import { List, Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const SubwayThreadDisplayRecord = Record({
  id: null,
  label: null,
  initials: null,
  color: null,
  lineStyle: null,
  anchorY: null,
  top: null,
  bottom: null,
  typeId: null,
  typeIcon: null,
  typeIconColor: null,
  typeLabel: null,
  typeLabelDisplay: null,
  addIconX: null,
  vertices: List()
});

const data = {
  objects: {
    vertices: "List"
  }
};
createFromJS.registerCallback(
  "SubwayThreadDisplayRecord",
  createFromJS.createNestedCallback(SubwayThreadDisplayRecord, data)
);
